import Password from "../Pages/Password";
import Registration from "../Pages/Registration";
import Migration, {MigrationAction} from "../Pages/Migration";
import TransitionWrapper from "./TransitionWrapper";
import Banner from "../Common/Banner";
import SignIn from "../Pages/SignIn";
import CustomerService from "../Pages/CustomerService";
import {ReactNode} from "react";
import {useProxy} from "../Custom Hooks/useProxy";
import SetupMfa from "../Pages/SetupMfa";
import ConfirmPhoneFactor from "../Pages/ConfirmPhoneFactor";
import PhoneFactor from "../Pages/PhoneFactor";
import ResetPassword from "../Pages/ResetPassword";
import EnterEmail from "../Pages/EnterEmail";
import VerifyEmail from "../Pages/VerifyEmail";
import Response from "../Pages/Response";
import ResetMfa from "../Pages/ResetMfa";
import ResetMfaEmailVerify from "../Pages/ResetMfaEmailVerify";

export default function Selector() {
  let displayed: ReactNode;
  const {name, type} = useProxy();

  switch (name) {
    case "SelfAsserted":
      switch (type) {
        case "signUp":
          displayed = <SignUpChildren/>;
          break;
        case "mfaSetup":
          displayed = <SetupMfaChildren/>;
          break;
        case "enterEmail":
          displayed = <EnterEmailChildren/>;
          break;
        case "verifyEmail":
          displayed = <VerifyEmailChildren/>;
          break;
        case "resetPassword":
          displayed = <ResetPasswordChildren/>;
          break;
        case "resetMfa":
          displayed = <ResetMfaVerifyChildren />;
          break;
        case "response":
          displayed = <ResponseChildren/>;
          break;
        case "migration":
          displayed = <MigrationChildren/>;
          break;
        default:
          displayed = <></>;
      }
      break;
    case "Unified":
      displayed = <SignInChildren/>;
      break;
    case "Phonefactor":
      if (type === "resetMfa") {
        displayed = <ResetMfaChildren/>;
      } else if (type === "mfaSetup") {
        displayed = <SetupPhoneFactorChildren/>;
      } else if (type === "mfa") {
        displayed = <PhoneFactorChildren/>;
      } else {
        displayed = <></>;
      }
      break;
    default:
      displayed = <></>;
  }

  return (<ContentWrapper>
      <FormContentWrapper>
        {displayed}
      </FormContentWrapper>
      <Banner/>
    </ContentWrapper>);
}

function ContentWrapper(props: { children: React.ReactNode }) {
  return (<div className="content-wrapper">
      {props.children}
    </div>)
}

function FormContentWrapper(props: { children: React.ReactNode }) {
  return (<div className="form-content-wrapper">
      {props.children}
    </div>)
}

function SignUpChildren() {
  return (<TransitionWrapper>
      <Registration/>
      <Password/>
    </TransitionWrapper>);
}

function MigrationChildren() {
  return (<TransitionWrapper>
      <Migration defaultMigrationAction={MigrationAction.None}/>
      <Password/>
    </TransitionWrapper>);
}

function SignInChildren() {
  return (<TransitionWrapper>
      <SignIn/>
      <CustomerService/>
    </TransitionWrapper>);
}

function SetupPhoneFactorChildren() {
  return (<TransitionWrapper>
      <ConfirmPhoneFactor/>
    </TransitionWrapper>);
}

function SetupMfaChildren() {
  return (<TransitionWrapper>
      <SetupMfa/>
    </TransitionWrapper>);
}

function ResetMfaVerifyChildren() {
  return (
    <TransitionWrapper>
     <ResetMfaEmailVerify />
     <ResetMfa />
    </TransitionWrapper>
  );
}

function ResetMfaChildren() {
  return (
    <TransitionWrapper>
      <ResetMfa />
    </TransitionWrapper>
  );
}

function PhoneFactorChildren() {
  return (<TransitionWrapper>
      <PhoneFactor/>
    </TransitionWrapper>);
}

function EnterEmailChildren() {
  return (<TransitionWrapper>
      <EnterEmail/>
    </TransitionWrapper>);
}

function VerifyEmailChildren() {
  return (<TransitionWrapper>
      <VerifyEmail/>
    </TransitionWrapper>);
}

function ResetPasswordChildren() {
  return (<TransitionWrapper>
      <ResetPassword/>
    </TransitionWrapper>);
}

function ResponseChildren() {
  return (<TransitionWrapper>
      <Response/>
    </TransitionWrapper>);
}
